module.exports = __webpack_public_path__ + "img/mobile-elbow-4_106x54.ce3a5dbd.png";